import { DOOR_LOCK } from './door-lock.type';
import { BLINDS } from './blinds.type';
import { FAN } from './fan.type';

export const CommandTypes = [
  DOOR_LOCK,
  BLINDS,
  FAN,
];



// WEBPACK FOOTER //
// ./~/@c4/programming/src/app/quickstarts/quickstart-simple/command-types/command-types.ts